
import Flows from '../../views/flows/Flows.vue'
import Flow from '../../views/flows/Flow.vue'
import FlowGeneral from '../../views/flows/FlowGeneral.vue'
import FlowStatus from '../../views/flows/FlowStatus.vue'
import FlowSuppliers from '../../views/flows/FlowSuppliers.vue'
import FlowTranslations from '../../views/flows/FlowTranslations.vue'
import FlowVerification from '../../views/flows/FlowVerification.vue'
import FlowSelfEvaluation from '../../views/flows/FlowSelfEvaluation.vue'
import FlowAuditDayRoot from '../../views/flows/FlowAuditDayRoot,.vue'
import FlowAudit from '../../views/flows/FlowAudit.vue'
import FlowAuditDay from '../../views/flows/FlowAuditDay.vue'

import FlowEducation from '../../views/flows/FlowEducation.vue'
import FlowConditions from '../../views/flows/FlowConditions.vue'
import FlowCondition from '../../views/flows/FlowCondition.vue'
import FlowNewQuestionlist from '../../views/flows/FlowNewQuestionlist.vue'
import FlowAuditdayNewQuestionlist from '../../views/flows/FlowAuditdayNewQuestionlist.vue'
import flowNewEducationPack from '../../views/flows/flowNewEducationPack.vue'
import FlowExpenses from '../../views/flows/FlowExpenses.vue'
import FlowCustomResultDisplay from '../../views/flows/FlowCustomResultDisplay.vue'
import CreateFlowCustomResultDisplay from '../../views/flows/CreateFlowCustomResultDisplay.vue'
import FlowCustomResultDisplays from '../../views/flows/FlowCustomResultDisplays.vue'
import FlowNonconformities from '../../views/flows/FlowNonconformities.vue'

import {roleSystemRoute} from './route_utilities'


export const flows = {
      path: 'flows',
      name: 'Flows',
      component: Flows,
      meta: {
          title: "akislar",
          domain:"flows",
          accessroles:["admin","brand","auditor","planner"],
        },
      }


export const flow =  {
      path: 'flow/:id',  
      name: 'Flow',
      component: Flow,
      redirect: { name: 'FlowStatus' },
      meta: {
          title: "akis",
          preloader:true,
          domain:"flows",
          accessroles:["admin","brand","auditor","planner"],
        },
        children:[
          {
          path: 'status',  
          name: 'FlowStatus',
          component: FlowStatus,
          meta: {
              title: "durum",
              preloader:true,
              domain:"flows"
            },
          },
          {
          path: 'business_return',  
          name: 'FlowExpenses',
          component: FlowExpenses,
          meta: {
              title: "is_bedelleri",
              preloader:true,
              domain:"flows"
            },
          },
          {
          path: 'result_displays',  
          name: 'FlowCustomResultDisplays',
          component: FlowCustomResultDisplays,
          meta: {
              title: "sonuc_ekranlari",
              preloader:true,
              domain:"flows"
            },
          },
          {
          path: 'flow_nonconformities',  
          name: 'FlowNonconformities',
          component: FlowNonconformities,
          meta: {
              title: "uygunsuzluklar",
              preloader:true,
              domain:"flows"
            },
          },
          {
          path: 'create_result_display',  
          name: 'CreateFlowCustomResultDisplay',
          component: CreateFlowCustomResultDisplay,
          meta: {
              title: "yeni_sonuc_ekrani",
              preloader:true,
              domain:"flows"
            },
          },
          {
          path: 'result_display/:display_id',  
          name: 'FlowCustomResultDisplay',
          component: FlowCustomResultDisplay,
          meta: {
              title: "sonuc_ekrani",
              preloader:true,
              domain:"flows"
            },
          },
          {
          path: 'general',  
          name: 'FlowGeneral',
          component: FlowGeneral,
          meta: {
              title: "genel",
              preloader:true,
              domain:"flows"
            },
          },
          {
          path: 'suppliers',  
          name: 'FlowSuppliers',
          component: FlowSuppliers,
          meta: {
              title: "asama_tedarikcileri",
              preloader:true,
              domain:"flows"
            },
          },
          {
          path: 'conditions',  
          name: 'FlowConditions',
          component: FlowConditions,
          meta: {
              title: "otomasyonlar",
              preloader:true,
              domain:"flows"
            },
          },
          {
          path: 'condition',  
          name: 'CreateFlowCondition',
          component: FlowCondition,
          meta: {
              title: "yeni_otomasyon",
              preloader:true,
              domain:"flows"
            },
          },
          {
          path: 'condition/:condition_id',  
          name: 'FlowCondition',
          component: FlowCondition,
          meta: {
              title: "otomasyon",
              preloader:true,
              domain:"flows"
            },
          },
          {
          path: 'translations',  
          name: 'FlowTranslations',
          component: FlowTranslations,
          meta: {
              title: "ceviriler",
              preloader:true,
              domain:"flows"
            },
          },
          {
          path: 'verification',  
          name: 'FlowVerification',
          component: FlowVerification,
          meta: {
              title: "verification",
              preloader:true,
              domain:"flows"
            },
          },
          {
          path: 'self_evaluation',  
          name: 'FlowSelfEvaluation',
          component: FlowSelfEvaluation,
          meta: {
              title: "self_evaluation",
              preloader:true,
              domain:"flows"
            },
          },
          {
          path: 'audit',  
          name: 'FlowAudit',
          component: FlowAudit,
          meta: {
              title: "audit",
              preloader:true,
              domain:"flows"
            },
          },
          {
          path: 'auditday',  
          name: 'CreateFlowAuditDay',
          component: FlowAuditDay,
          meta: {
              title: "denetleme",
              preloader:true,
              domain:"flows"
            },
          },

          {
          path: 'auditday/:auditday_id',  
          name: 'FlowAuditDayRoot',
          component: FlowAuditDayRoot,
          redirect:{name:"FlowAuditDay"},
          meta: {
              title: "denetleme",
              preloader:true,
              domain:"flows"
            },
            children:[
          {
          path: '',  
          name: 'FlowAuditDay',
          component: FlowAuditDay,
          meta: {
              title: "denetleme",
              preloader:true,
              domain:"flows"
            },
          },
          {
          path: 'create_questionlist',  
          name: 'FlowAuditdayNewQuestionlist',
          component: FlowAuditdayNewQuestionlist,
          meta: {
              title: "denetleme",
              preloader:true,
              domain:"flows"
            },
          },

            ]
          },
          {
          path: 'education',  
          name: 'FlowEducation',
          component: FlowEducation,
          meta: {
              title: "egitim",
              preloader:true,
              domain:"flows"
            },
          },
          {
          path: 'questionlist',  
          name: 'FlowNewQuestionlist',
          component: FlowNewQuestionlist,
          meta: {
              title: "yeni_soru_listesi",
              preloader:true,
              domain:"flows"
            },
          },
          {
          path: 'educationpack',  
          name: 'flowNewEducationPack',
          component: flowNewEducationPack,
          meta: {
              title: "yeni_egitim_paketi",
              preloader:true,
              domain:"flows"
            },
          }
          
        ]
      }